import React, { useEffect, useMemo } from 'react';
import CustomModal from '../../baseComponents/gui/customModal/CustomModal';
import { safeHTML } from '../../../utils/safeHTML';
import CustomButton from '../../features/customButton/ui/main/CustomButton';
import SelectLangButton from '../../features/selectLangButton/SelectLangButton';
import { useTranslation, defaultStore, stores, languages } from '../../../translations';
import { useLanguageControls } from '../../../hooks/useLanguageControls';
import { inactiveGameRefactoring, getPlugKeyByLanguage } from '../../../constants/copyright-modals';
import { useCurrentStore } from '../../../hooks/useCurrentStore';
import { copyrightParams } from '../../../constants/copyright';
import { useParams } from '../../../redux/reducer/content';
import { useApplicationCallbacks } from '../../../providers/application-callbacks';

const InactiveAppModal = React.forwardRef(function InactiveAppModal() {
  const { image, copyright, isSelectLangButton } = inactiveGameRefactoring;
  const { t } = useTranslation();
  const { language } = useLanguageControls();

  const store = useCurrentStore();
  const params = useParams();
  const callbacks = useApplicationCallbacks();

  useEffect(() => {
    if (!params) {
      callbacks.getParams();
    }
  }, [params, callbacks]);

  const { header, text, buttonText, buttonLink } = useMemo(() => {
    const key = getPlugKeyByLanguage(language ?? languages.ru);
    const block = params?.[key] ?? {};

    return {
      header: block.header ?? '',
      text: block.text ?? '',
      buttonText: block.text_button ?? '',
      buttonLink: `https://goldapple.${store}`,
    };
  }, [params, store, language]);

  return (
    <CustomModal>
      <div className='inactive-game-modal__container'>
        <div className='inactive-game-modal__image-wrapper'>
          <img src={image} alt='title' />
        </div>

        <div className='inactive-game-modal__content-wrapper'>
          <div className='inactive-game-modal__inner-content'>
            <div className='inactive-game-modal__text-content'>
              <h1 className='inactive-game-modal__main-title'>{safeHTML(header)}</h1>
              <span className='inactive-game-modal__description'>{safeHTML(text)}</span>
            </div>
            {defaultStore !== stores.ru && isSelectLangButton && (
              <SelectLangButton isIcon className={'inactive-game-modal__lang'} />
            )}
            {buttonText && <CustomButton text={buttonText} tag='a' href={buttonLink} target='_blank' />}
          </div>

          <span className='inactive-game-modal__copyright-text'>{safeHTML(t(copyright, copyrightParams))}</span>
        </div>
      </div>
    </CustomModal>
  );
});

export default InactiveAppModal;
InactiveAppModal.propTypes = {};
